import { connect } from 'react-redux';
import ResetPasswordComponent from '../components/ResetPasswordComponent';
import { resetPassword } from '../actions/ProfileActions';

const mapStateToProps = (state) => ({
    submitting: state.profile.submitting,
    passwordResetted: state.profile.passwordResetted,
});

const mapDispatchToProps = (dispatch) => ({
    resetPassword: (userId, newPassword, resetToken) => {
        dispatch(resetPassword(userId, newPassword, resetToken));
    },
});

const ResetPasswordContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ResetPasswordComponent);

export default ResetPasswordContainer;
